import {FileDetailActivitiesComponent} from './components/file-detail-activities/file-detail-activities.component';
import {
  FileDetailRelatedObjectsComponent
} from './components/file-detail-related-objects/file-detail-related-objects.component';
import {
  FileDetailPermissionSettingsComponent
} from './components/file-detail-shared/file-detail-permission-settings.component';
import {NotImplementedComponent} from '|shared';
import {IczRoutes} from '@icz/angular-application-core';
import {FileDetailContentComponent} from './components/file-detail-content/file-detail-content.component';
import {FileDetailHistoryComponent} from './components/file-detail-history/file-detail-history.component';
import {FileDetailPreviewComponent} from './components/file-detail-preview/file-detail-preview.component';
import {FileDetailRoute} from './enums/file-detail-routes.enum';
import {FileDetailComponent} from './file-detail.component';
import {
  ObjectDetailTransferIncidentsComponent
} from '../document-shared/components/object-detail-transfer-incidents/object-detail-transfer-incidents.component';
import {FileDetailSubjectsComponent} from './components/file-detail-subjects/file-detail-subjects.component';
import {SharedRoute} from '|ui-essl-core';

const FILE_DETAIL_PAGE_NAME: string = 'Detail spisu';

export const ROUTES: IczRoutes = [
  {
    path: '',
    title: FILE_DETAIL_PAGE_NAME,
    component: FileDetailComponent,
    children: [
      {
        path: '',
        title: FILE_DETAIL_PAGE_NAME,
        redirectTo: FileDetailRoute.CONTENT,
        pathMatch: 'full'
      },
      {
        path: FileDetailRoute.PREVIEW,
        title: FILE_DETAIL_PAGE_NAME,
        component: FileDetailPreviewComponent,
        data: {
          fallbackBreadcrumbUri: FileDetailRoute.CONTENT,
          usesAlias: true
        }
      },
      {
        path: FileDetailRoute.CONTENT,
        title: FILE_DETAIL_PAGE_NAME,
        component: FileDetailContentComponent,
      },
      {
        path: FileDetailRoute.HISTORY,
        title: FILE_DETAIL_PAGE_NAME,
        component: FileDetailHistoryComponent,
        data: {
          fallbackBreadcrumbUri: FileDetailRoute.CONTENT,
          usesAlias: true,
        }
      },
      {
        path: FileDetailRoute.SUBJECTS,
        title: FILE_DETAIL_PAGE_NAME,
        component: FileDetailSubjectsComponent,
        data: {
          fallbackBreadcrumbUri: FileDetailRoute.CONTENT,
          usesAlias: true,
        }
      },
      {
        path: FileDetailRoute.SHARE,
        title: FILE_DETAIL_PAGE_NAME,
        component: FileDetailPermissionSettingsComponent,
        data: {
          fallbackBreadcrumbUri: FileDetailRoute.CONTENT,
          usesAlias: true,
        }
      },
      {
        path: FileDetailRoute.RELATED,
        title: FILE_DETAIL_PAGE_NAME,
        component: FileDetailRelatedObjectsComponent,
        data: {
          fallbackBreadcrumbUri: FileDetailRoute.CONTENT,
          usesAlias: true,
        }
      },
      {
        path: FileDetailRoute.ACTIVITIES,
        title: FILE_DETAIL_PAGE_NAME,
        component: FileDetailActivitiesComponent,
        data: {
          fallbackBreadcrumbUri: FileDetailRoute.CONTENT,
          usesAlias: true,
        }
      },
      {
        path: FileDetailRoute.INCIDENTS,
        title: FILE_DETAIL_PAGE_NAME,
        component: ObjectDetailTransferIncidentsComponent,
        data: {
          fallbackBreadcrumbUri: FileDetailRoute.CONTENT,
          usesAlias: true,
        }
      },
      {
        path: SharedRoute.NOT_IMPLEMENTED,
        title: FILE_DETAIL_PAGE_NAME,
        component: NotImplementedComponent,
        data: {
          fallbackBreadcrumbUri: FileDetailRoute.CONTENT,
          usesAlias: true,
        },
      },
    ],
  },
];
